import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import AdminDashboard from './pages/AdminDashboard';
import ClientDashboard from './pages/ClientDashboard';
import Clients from './pages/Clients';
import Projects from './pages/Projects';
import Invoices from './pages/Invoices';
import Files from './pages/Files';
import Messages from './pages/Messages';

const ProtectedRoute = ({ children, role }) => {
  const { userInfo } = useAuth();
  if (!userInfo) return <Navigate to="/login" />;
  if (role && userInfo.role !== role) return <Navigate to="/login" />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/admin/dashboard" element={
            <ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>
          } />
          <Route path="/admin/clients" element={
            <ProtectedRoute role="admin"><Clients /></ProtectedRoute>
          } />
          <Route path="/admin/projects" element={
            <ProtectedRoute role="admin"><Projects /></ProtectedRoute>
          } />
          <Route path="/admin/invoices" element={
            <ProtectedRoute role="admin"><Invoices /></ProtectedRoute>
          } />
          <Route path="/admin/files" element={
            <ProtectedRoute role="admin"><Files /></ProtectedRoute>
          } />
          <Route path="/admin/messages" element={
            <ProtectedRoute role="admin"><Messages /></ProtectedRoute>
          } />
          <Route path="/client/dashboard" element={
            <ProtectedRoute role="client"><ClientDashboard /></ProtectedRoute>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;